import React from 'react';
import LayersHeading from 'components/customComponents/Layers/LayersHeading';

function WizardContentParent({
  heading,
  children,
  style = null,
  headingStyle = null,
  childStyle = null,
  className = '',
}: any) {
  return (
    <div id='wizardcontentparent-wrapper'
      className={`dashed-border create-exp-options ${className}`}
      style={{
        height: '100%',
        width: '100%',
        paddingTop: 0,
        ...style,
      }}
    >
      <LayersHeading
        text={heading}
        style={{
          margin: '7px 0px',
          height: '34px',
          display: 'flex',
          alignItems: 'center',
          ...headingStyle,
        }}
      />
      <div id='wizardcontentparent-content' style={{ height: '95%', ...childStyle }}>{children}</div>
    </div>
  );
}

export default WizardContentParent;
